const createElement = function (css, elType, id, innerHtml) {
    const el = document.createElement(elType || 'div');
    if (css) {
        el.className = css;
    }
    if (id) {
        el.setAttribute('id', id);
    }
    if (innerHtml) {
        el.innerHTML = innerHtml;
    }
    // apply default tabindex
    el.setAttribute('tabindex', -1);
    return el;
};
export default createElement;
